import CommonStyles from 'shared/style/commonPageStyles'
import styled, {css} from 'styled-components'

const Style = {
	Wrapper: CommonStyles.PageWrapper,

	Data: styled.p`
		height: fit-content;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;

		${({theme}) => theme.font.extra_small};

		${({$title}) =>
			$title &&
			css`
				color: ${({theme}) => theme.color.white};
				${({theme}) => theme.font.extra_small_bold};
			`}

		${({$size}) => {
			if ($size === 'short')
				return css`
					width: 50px;
				`
			else if ($size === 'long')
				return css`
					width: 150px;
				`
			else if ($size === 'longlong')
				return css`
					width: 200px;
				`
			else if ($size === 'longlonglong')
				return css`
					width: 250px;
				`
			else if ($size === 'expand')
				return css`
					flex-grow: 1;
				`
			else
				return css`
					width: 100px;
				`
		}}
        
        ${({$break}) =>
			$break &&
			css`
				color: ${({theme}) => theme.color.white};
				${({theme}) => theme.font.extra_small_bold};
			`}
	`,
}

export default Style
